<script>
export default {
  name: 'LazyRenderer',
  data() {
    return {
      render: false,
    };
  },
  mounted() {
    const isIntersectionObserverSupported = 'IntersectionObserver' in window
        && 'IntersectionObserverEntry' in window
        && 'intersectionRatio' in window.IntersectionObserverEntry.prototype
        && 'isIntersecting' in window.IntersectionObserverEntry.prototype;

    if (!isIntersectionObserverSupported) {
      this.render = true;
      return;
    }

    const observer = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting) {
          this.render = true;
          observer.unobserve(this.$el);
        }
      },
      {
        rootMargin: '100px',
        threshold: 0,
      },
    );

    observer.observe(this.$el);
  },
};
</script>

<template lang="pug">
  .lazy-renderer
    slot(v-if="render")
</template>
